import "./Tabs.scss";
import { useState } from "react";
export default function Tabs({
  navItem,
  tabContent,
  type,
  myFunction = () => {},
  className,
}) {
  const [activ, setActive] = useState([0]);

  return (
    <div className=" p-4 p-verticaltab">
      <div className={`${className}`}>
        {type == "vertical" ? (
          <div className="box d-flex ">
            <div className="tab-right ">
              <ul
                style={{ display: "block" }}
                className="nav nav-pills border-end  h-100"
                role="tablist"
              >
                {navItem.map((val, ind) => {
                  return (
                    <li
                      className={`nav-item px-3 py-2 ${
                        activ == ind && "box-nav2"
                      }`}
                    >
                      <button
                        type="button"
                        className={`nav-link-custom  ${
                          activ == ind && "active-tab "
                        } `}
                        role="tab"
                        data-bs-toggle="tab"
                        data-bs-target={val.target}
                        aria-controls="navs-pills-left-home"
                        aria-selected="true"
                        aria-label="scrollable auto tabs example"
                        onClick={(e) => {
                          setActive(ind);
                          myFunction();
                        }}
                      >
                        {val.title}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="tab-content p-3 w-100">
              {tabContent.map((val, ind) => {
                return (
                  <div
                    className={`tab-pane  ${activ == ind && "active"}`}
                    id={val.id}
                    role="tabpanel"
                  >
                    {val.component}
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="box-horis  ">
            <div className="tab-right  ">
              <ul
                className="nav nav-horis nav-pills  h-100 d-flex"
                role="tablist"
              >
                {navItem.map((val, ind) => {
                  return (
                    <li className={`nav-item  ${activ == ind && "box-nav"}`}>
                      <button
                        type="button"
                        className={`nav-link-custom px-3 py-2  ${
                          activ == ind && "active-tab "
                        } `}
                        role="tab"
                        data-bs-toggle="tab"
                        data-bs-target={val.target}
                        aria-controls="navs-pills-left-home"
                        aria-selected="true"
                        aria-label="scrollable auto tabs example"
                        onClick={(e) => {
                          setActive(ind);
                          myFunction();
                        }}
                      >
                        {val.title}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="tab-content p-3">
              {tabContent.map((val, ind) => {
                return (
                  <div
                    className={`tab-pane  ${activ == ind && "active"}`}
                    id={val.id}
                    role="tabpanel"
                  >
                    <p>{val.component}</p>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
